import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useUserRole } from '../../context/UserRoleContext';
import { canAccessRoute } from '../security/rbac';

const DevRouteGuard = ({ children }) => {
  const { currentUser } = useAuth();
  const { userRole } = useUserRole();
  const roles = userRole ? [userRole] : [];

  if (!currentUser) {
    return <Navigate to="/landing" replace />;
  }

  if (!canAccessRoute(roles)) {
    return <Navigate to="/admin" replace />;
  }

  return <>{children}</>;
};

export default DevRouteGuard;
